import { Prisma } from '@prisma/client';
import { ProductEmissionInclude, ProductEmissionSelect } from '../includes/Emission';
var IncludeEmissionCalculation = Prisma.validator()({
    include: ProductEmissionInclude,
});
var SelectEmissionCalculation = Prisma.validator()({
    select: ProductEmissionSelect,
});
//# sourceMappingURL=ProductEmission.js.map